/* eslint-disable formatjs/no-literal-string-in-jsx */

import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import loginImg from "../../../assets/img/login-compressed.jpg";
import logo from "../../../assets/img/variants/cleverfarm/login-logo.png";
import { LangSwitch } from "../../components/specific/LangSwitch/LangSwitch";
import Localization from "../../services/Localization.service";

type Props = React.PropsWithChildren<{
  isFetching?: boolean;
}>;

const EntryContainer = ({ children, isFetching }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Paper className={classes.paper} sx={{ width: { sx: "100%", sm: 450 } }}>
        <img alt="company logo" className={classes.logo} src={logo} />
        <LangSwitch
          className={classes.langSwitch}
          onLangChange={Localization.setLang}
        />
        <Box mx={4}>{children}</Box>
        {isFetching && (
          <div className={classes.spinner} id="spinner">
            <CircularProgress />
          </div>
        )}
      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100vh",
    backgroundImage: `url(${loginImg})`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    "-webkit-background-size": "cover",
    "-moz-background-size": "cover",
    "-o-background-size": "cover",
    backgroundSize: "cover",
    margin: 0,
    padding: 16,
    position: "relative",
  },
  paper: {
    backgroundColor: "rgba(255,255,255,0.95)",
    padding: "0px 24px 32px 24px",
    position: "relative",
  },
  spinner: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    zIndex: 999,
    top: 0,
    borderRadius: "2px",
    backgroundColor: "rgba(236,236,236,0.9)",
  },
  logo: {
    ...theme.assets.login.style,
    content: `url(${theme.assets.login.src})`,
  },
  headerGrid: {
    width: "100%",
  },
  langSwitch: {
    right: "8px",
    position: "absolute",
    top: 0,
  },
}));

export { EntryContainer };
